<mat-accordion class="app-localisation-accordion" attr.data-open="{{isLocalised}}">
	<mat-expansion-panel [expanded]="isLocalised" [disabled]="isLocalised" [hideToggle]="isLocalised" style="margin-bottom: 5px;">
		<mat-expansion-panel-header class="app-localisation-header">
			<mat-panel-title>Localisation</mat-panel-title>
		</mat-expansion-panel-header>

		<div class="d-flex justify-content-between align-items-center">
			<mat-form-field appearance="standard">
				<mat-label>Search</mat-label>
				<input matInput (keyup)="search($event)" placeholder="Ex. EN" #input>
			  </mat-form-field>

			<app-search-select
				[data]="availableLocales"
				[disableSelect]="true"
				(selectedChange)="addLocale($event)"
				[disabled]="locales.length === 0"
				btnColor='accent'
				tooltip="Add locales for additional localisation"
				i18n-tooltip
				title="Add locale"
				i18n-title
				class="locale-select d-inline-block"
			></app-search-select>
		</div>

		<form [formGroup]="formInputs">
			<div class="table-responsive" formGroupName="localisation">
				<table
					mat-table
					[dataSource]="tableDataSource"
					class="w-100"
					multiTemplateDataRows
					matSort
					matSortActive="language"
					matSortDirection="asc"
					aria-label="List of selected event hooks"
				>
					<ng-container matColumnDef="id">
						<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef mat-sort-header i18n>Locale</th>
						<td mat-cell *matCellDef="let row" class="text-nowrap">{{row.id}}</td>
					</ng-container>

					<ng-container matColumnDef="language">
						<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef mat-sort-header i18n>Language</th>
						<td mat-cell *matCellDef="let row" class="text-nowrap">{{row.language}}</td>
					</ng-container>

					<ng-container matColumnDef="name">
						<th scope="col" mat-header-cell *matHeaderCellDef>Document name</th>
						<td mat-cell *matCellDef="let row; let i = dataIndex" class="actions no-wrap" [formGroupName]="row.id">
							<mat-form-field appearance="standard" class="w-100 legal-localisation__name">
								<input matInput type="text" placeholder="Name" i18n-placeholder formControlName="displayName" />
								<mat-error
									appFormErrorMessage
									[errorFormControl]="formInputs.controls[row.id + '-displayName']"
									[type]="formEditorInputType.text"
								></mat-error>
							</mat-form-field>
						</td>
					</ng-container>

					<ng-container matColumnDef="action" [stickyEnd]="true">
						<th scope="col" mat-header-cell *matHeaderCellDef class="text-center"></th>
						<td mat-cell *matCellDef="let row; let i = dataIndex" class="actions text-center no-wrap">
							<button
								mat-icon-button
								type="button"
								(click)="removeLocale(row.id)"
								title="Remove"
								i18n-title
								class="text-danger app-legal-remove-locale"
							>
								<mat-icon>delete</mat-icon>
							</button>
						</td>
					</ng-container>

					<tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
					<tr mat-row *matRowDef="let row; columns: tableColumns; let i = dataIndex;"></tr>
				</table>
			</div>
		</form>

		<mat-paginator
			[pageSizeOptions]="[10, 20, 40]"
			showFirstLastButtons
			aria-label="Select page of event hook mappings"
		></mat-paginator>
	</mat-expansion-panel>
</mat-accordion>
